// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Accordion from '../../../shared/components/smart-accordion/state/accordion';
import AmountOfUseAccordion from './update-amount-of-use';
import AuditCount from '@deere/cps-it.warranty-model-factory/lib/audit-count';
import AuditCountPanel from './audit-count-panel';
import ClosingAccountAccordion from './closing-account';
import DealerHierarchyFacet from '../../shared/state/dealer-hierarchy-facet';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import DuplicatePinPlateAccordion from './duplicate-pin-plate';
import FacetsAccordion from './facets';
import {FormattedMessage} from 'react-intl';
import LaborRateChangesAccordion from './labor-rate-changes';
import {Link} from 'react-router';
import LinkType from '@deere/cps-it.warranty-model-factory/lib/link';
import MachineStatusUpdatesAccordion from './machine-status-updates';
import PipCodeRequestsAccordion from './pip-code-requests';
import ReportLinks from '../../../shared/components/report-links';
import SearchBox from '../../../shared/components/search-box';
import SearchByDropDown from '../state/search-by-dropdown';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import SpaAccordion from './special-allowance';
import TcsmSettings from '@deere/cps-it.warranty-model-factory/lib/tcsm-settings';
import UsefulLinksPanel from './useful-links-panel';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getIsPinTransferEnabled} from '../../../product/shared/services/get-is-pin-transfer-enabled-aor';
import {hasAccess} from '../../../shared/services/security';
import {mapSearchPlaceHolder} from '../../../home-page/shared/services/home-page-helper';

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function readMachineStatusUpdatesIfAuthorized() {

    if (this.state.showMachineStatus) {

        this.props.actions.readMachineStatusUpdates(this.props.wipFacets.dealers);

    }

}

function readPipCodeRequestsIfAuthorized() {

    if (this.state.showPipCode) {

        this.props.actions.readPipCodeRequests(this.props.wipFacets.dealers);

    }

}

function readSpaClaimsIfAuthorized() {

    if (this.state.showSpa) {

        this.props.actions.readSpaClaims(this.props.wipFacets.dealers, this.props.tcsmSettings.selectedSpaLevels);

    }

}

function readLaborRateChangesIfAuthorized() {

    if (this.state.showLaborRate) {

        this.props.actions.readLaborRateChanges(this.props.wipFacets.dealers);

    }

}

function readClosingAccountIfAuthorized() {

    this.props.actions.readClosingAccount(this.props.wipFacets.dealers);

}

function readDuplicatePinPlateIfAuthorized() {

    this.props.actions.readDuplicatePinPlate(this.props.wipFacets.dealers);

}

function readAmountOfUseIfAuthorized() {

    if (getIsPinTransferEnabled('add-amount-of-use')) {

        this.props.actions.readAmountOfUseRequests(this.props.wipFacets.dealers);

    }

}

function readAuditCountIfAuthorized() {

    if (this.state.showAuditPanel) {

        this.props.actions.readAuditCount();

    }

}

function handleAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

class TcsmWip extends Component {

    state = {
        showAuditPanel: hasAccess(this.context.security, 'TCSM', 'TCSM_AUDIT_READ'),
        showLaborRate: hasAccess(this.context.security, 'TCSM', 'TCSM_LABOR_RATE_READ'),
        showMachineStatus: hasAccess(this.context.security, 'TCSM', 'TCSM_MACHINE_STATUS_READ'),
        showPipCode: hasAccess(this.context.security, 'TCSM', 'TCSM_PIP_CODE_READ'),
        showSpa: hasAccess(this.context.security, 'TCSM', 'TCSM_SPL_ALLOWANCE_READ')
    };

    componentWillMount() {

        if (this.props.initialLoad) {

            this.props.actions.updateInitialLoad(false);

            if (this.props.territories.length < 1 || this.props.wipFacets.dealers.length < 1) {

                this.props.actions.readTerritories(this.props.user.id, this.state);

            } else {

                this::readAmountOfUseIfAuthorized();
                this::readClosingAccountIfAuthorized();
                this::readDuplicatePinPlateIfAuthorized();
                this::readMachineStatusUpdatesIfAuthorized();
                this::readPipCodeRequestsIfAuthorized();
                this::readSpaClaimsIfAuthorized();
                this::readLaborRateChangesIfAuthorized();
                this.props.actions.updateFilteredTerritories(this.props.territories);

            }

        } else {

            this::readAmountOfUseIfAuthorized();
            this::readClosingAccountIfAuthorized();
            this::readDuplicatePinPlateIfAuthorized();
            this::readMachineStatusUpdatesIfAuthorized();
            this::readPipCodeRequestsIfAuthorized();
            this::readSpaClaimsIfAuthorized();
            this::readLaborRateChangesIfAuthorized();

        }

        this::readAuditCountIfAuthorized();

    }

    componentWillUnmount() {

        this.props.actions.closeMachineStatusModal();
        this.props.actions.closePipCodeRequestModal();

    }

    render() {

        return (
            <section className='tcsm-wip'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='tcsm-homepage-aside'>
                    <FacetsAccordion/>
                    {this.state.showAuditPanel && <AuditCountPanel auditCount={this.props.auditCount}/>}
                    <div className='claim-debit-link'>
                        <Link to='/tcsm/claim-debit'>
                            <FormattedMessage id='REQUEST_WARRANTY_CLAIM_DEBIT'/>
                        </Link>
                    </div>
                    <ReportLinks
                        accordion={this.props.reportsAccordion}
                        onAccordionToggle={this.props::handleAccordionToggle}
                        parentRoute='tcsm'
                        routes={this.props.reportsRoutes}
                    />
                    <UsefulLinksPanel links={this.props.links}/>
                </aside>
                <main className='tcsm-homepage-main'>
                    <SearchBox
                        defaultOption={this.props.searchByDropDown.selectedOption.key}
                        onOptionChange={this.props.actions.updateSearchByDropDown}
                        onQueryChange={this.props.actions.updateSearchQueryString}
                        onSearch={this.props::handleSearch}
                        placeholderText={mapSearchPlaceHolder(this.props.searchByDropDown.selectedOption.key)}
                        queryString={this.props.searchQueryString}
                        searchBy={this.props.searchByDropDown.searchBy}
                    />
                    {this.state.showSpa && <SpaAccordion/>}
                    {this.state.showMachineStatus && <MachineStatusUpdatesAccordion/>}
                    {this.state.showPipCode && <PipCodeRequestsAccordion/>}
                    {this.state.showLaborRate && <LaborRateChangesAccordion/>}
                    <ClosingAccountAccordion/>
                    <DuplicatePinPlateAccordion/>
                    {getIsPinTransferEnabled('add-amount-of-use') && <AmountOfUseAccordion/>}
                </main>
            </section>
        );

    }

}

TcsmWip.displayName = 'TcsmWip';
TcsmWip.propTypes = {
    actions: PropTypes.object.isRequired,
    auditCount: PropTypes.instanceOf(AuditCount).isRequired,
    busyCounter: PropTypes.number.isRequired,
    initialLoad: PropTypes.bool.isRequired,
    links: PropTypes.arrayOf(PropTypes.instanceOf(LinkType)).isRequired,
    reportsAccordion: PropTypes.instanceOf(Accordion).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    tcsmSettings: PropTypes.instanceOf(TcsmSettings).isRequired,
    territories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    user: PropTypes.instanceOf(User).isRequired,
    wipFacets: PropTypes.instanceOf(DealerHierarchyFacet).isRequired
};
TcsmWip.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default TcsmWip;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/index.js